import { readonly } from 'vue'
import { useLocalStorage } from '@vueuse/core'
import type { FileViewerSettings } from '@lib/types/fileViewerSettings.types'

export default function useFileViewerSettings() {
  const localStorageKey = 'ciq_file_viewer_settings'
  const fileViewerSettings = useLocalStorage<FileViewerSettings>(localStorageKey, {
    fitMode: 'width',
  })

  function updateFileViewerSettings(partialSettings: Partial<FileViewerSettings>) {
    fileViewerSettings.value = { ...fileViewerSettings.value, ...partialSettings }
  }

  return {
    fileViewerSettings: readonly(fileViewerSettings),
    updateFileViewerSettings,
  }
}
